import { importedGroupModel } from './imported-group-model.js'
import { importedQuestionModel } from './imported-question-model.js'
import { overrideQuestionModel } from './override-question-model.js'
import { sum, formatNumber } from '../utils/std.js'

export class HtmlProcessor {
    constructor(sectionAggregator) {
        this.sectionAggregator = sectionAggregator;
    }
    translatePara(paraText, format, questions, groupAnswers, groupInputs) {
        return "<p>" + this.sectionAggregator.substituteText(paraText, format, questions, groupAnswers, groupInputs) + "</p>"
    }
    // TODO - sort out this hierarchy and use this method instead
    translateList(valuePairs) {
        return "<dl>" + valuePairs.map(i => "<dt class='font-weight-bold'>" + i.question + "</dt><dd class='pl-2'>" + i.answer + "</dd>").join('') + "</dl>"
    }
}

export class PdfProcessor {
    constructor(sectionAggregator) {
        this.sectionAggregator = sectionAggregator;
    }
    translatePara(paraText, format, questions, groupAnswers, groupInputs) {
        return this.sectionAggregator.substituteText(paraText, format, questions, groupAnswers, groupInputs) + "\r\n"
    }
    // TODO - sort out this hierarchy and use this method instead
    translateList(valuePairs) {
        return valuePairs.map(i => i.question + "\r\n\t" + i.answer + "\r\n")
    }
}

export class ScoreCalculator {
    constructor() {

    }
    scoreOpinions = [
        {
            low: 0,
            high: 2,
            title: 'Very low',
            comment: 'This score is very low, read the tips below to find out how to improve it!',
            color: "#FF0000"
        },
        {
            low: 2,
            high: 3,
            title: 'Low',
            comment: 'This score is low, read the tips below to find out how to improve it!',
            color: "#F97600"
        },
        {
            low: 3,
            high: 4,
            title: 'Good',
            comment: 'This score is good, but could be better. Read the tips below to find out how! ',
            color: "#F6C600"
        },
        {
            low: 4,
            high: 6,
            title: 'Excellent',
            comment: 'This score is excellent! Read the tips below to find out why!',
            color: "#60B044"
        }
    ]
    getOpinionForScore(score) {
        return this.scoreOpinions.find(o => o.low <= score && score < o.high)
    }
    
    findQ(questions, name) {
        return questions.find(q => q.name == name);
    }
    findQid(questions, id) {
        const q = questions.find(q => q.id == id);
        //console.assert(q, "findQid(questions, " + id + ") failed")
        return q;
    }
    // Look at all relevant UI questions & answers and construct value
    // for calculation model
    // calcQ is a member of importedQuestionModel 
    // answers was constructed from store.exportValuePairs(, false), 
    // so it is a map: imported-question-id => numeric-value
    resolveListQuestion(calcQ, questions, answers) {
        if (calcQ.id == 'C1') {
            return 101 // Not implemented
        }
        let a = answers[calcQ.id]
        return a != null  ? a : -1
    }
    // Convert a value (enumeration) to an item (for a list question)
    valueToItem(calcModel, value) {
        const item = calcModel.items.find(i => i.value == value);
        //console.assert(item, "valueToItem(calcModel, " + value + ") failed")
        return item
    }
    // Collect the answers given for a group
    aggregateAnswers(groupId, questions, answers) {
        const group = importedGroupModel.groupInfo.find(g => g.groupId == groupId);
        if (!group) {
            return {
                unweightedScore: 0.0,
                weight: 0.0,
                weightedScore: 0.0,
                items: []
            }
        }
        const items = group.questions.map(qid => {
            const calcQ = importedQuestionModel['model' + qid];
            //console.log("calcQ=" + calcQ + ' for ' + qid)
            //console.dir(calcQ)
            const value = this.resolveListQuestion(calcQ, questions, answers);
            const item = this.valueToItem(calcQ, value);
            //console.log("item")
            //console.dir(item)
            return {
                qid: qid,
                text: calcQ.text,
                value: value,
                unweightedScore: (item ? item.score : 0),
                weighting: calcQ.questionWeight,
                weightedScore: (item ? item.score : 0) * (calcQ.questionWeight / 5),
                response: item ? item.description : ''
            };
        });
        const totalScore = sum(items.map(i => i.weightedScore))
        const totalWeights = sum(items.map(i => i.weighting))/5
        const total = totalScore / (totalWeights ? totalWeights : 1)
        return {
            unweightedScore: total,
            weighting: group.weight,
            weightedScore: total * (group.weight/5),
            items: items
        }
    }
    // Collect the user inputs for a group
    aggregateInputs(groupId, questions, answers) {
        //console.log('aggregateInputs for ' + groupId)
        // Find the referenced group
        const group = importedGroupModel.groupInfo.find(g => g.groupId == groupId);
        // For each question in the group, we collect the relevant UI questions
        let inputs = [];
        group.questions.forEach(qid => {
            //console.log('input: ' + qid)
            var uiQ = this.findQid(questions, qid);
            if (!uiQ) {
                uiQ = overrideQuestionModel.questions.find(q => (q.type == 'scores')
                    && (q.items.find(oi => oi.id == qid)))
                    const uiS = uiQ ? uiQ.items.find(oi => oi.id == qid) : null
                    if (!uiS) {
                        return;
                    }
                    const calcQ = importedQuestionModel["model" + qid]
                    answerValue = answers[qid]
                    const scores = uiS.scores ? uiS.scores : overrideQuestionModel.getOptionsForQuestion(uiQ)
                    const score = scores.find(o => o.value == answerValue - uiS.offset);
                    //console.log("pushing '" + calcQ.questionShortText + "' or '" + calcQ.questionSupportText + "'")
                    inputs.push({
                        question: calcQ.questionShortText ? calcQ.questionShortText : calcQ.questionSupportText,
                        answer: score ? score.text : "NA"
                })
                return;
            }
            let eq = overrideQuestionModel.enrichQuestion(uiQ)
            let answerValue = answers[uiQ.id];
            if (uiQ.type == 'radio') {
                //console.log('radio input ' + qid + ' = ' + answerValue)
                const calcQ = importedQuestionModel["model" + qid]
                const selectedItem = eq.items.find(i => i.value == answerValue);
                //console.log("pushing '" + calcQ.questionShortText + "' or '" + calcQ.questionSupportText + "'")                
                inputs.push({
                    question: calcQ && calcQ.questionShortText ? calcQ.questionShortText : uiQ.title,
                    answer: selectedItem ? selectedItem.title : 'NA'
                })
            }
            else if (uiQ.type == 'flags') {
                // console.log('aggregateInputs for flags: ' + uiQ.name)
                // console.log('answerValue=' + answerValue)
                let answerValues = overrideQuestionModel.flagsValueToFlags(uiQ, answerValue)
                const answerTexts = ['Not sure', 'No', 'Yes']
                uiQ.items.forEach((item, index) => {
                    const answerIndex = Number(answerValues[index]) + 1;
                    //console.log('item: index=' + index + ', answerIndex=' + answerIndex)
                    //console.log('pushing: [' + item.title + '],[' + answerTexts[answerValue[index] + 1] + ']')
                    inputs.push({
                        question: item.title,
                        answer: answerTexts[answerIndex]
                    })
                })
            }
        })
        inputs = inputs.filter(i => i != null && i.answer != 'NA'); // Throw away any failures
        //console.dir(inputs)
        return inputs
    }
}

export class SectionAggregator {
    constructor() {
    }
    processText(rawText, format, questions, groupAnswers, groupInputs) {
        const processor = format == 'html'
            ? new HtmlProcessor(this)
            : new PdfProcessor(this)
        const paras = rawText.split('\n');
        return paras.map(p => processor.translatePara(p, format, questions, groupAnswers, groupInputs)).join('')
    }
    // eslint-disable-next-line no-unused-vars
    substituteText(rawText, format, questions, groupAnswers, groupInputs) {
        // See: https://regex101.com/
        let newText = rawText;
        const regex = /\[\[inputs\]\]/g;
        // eslint-disable-next-line no-unused-vars
        newText = newText.replace(regex, function (found) {
            //console.log("Translating '" + found + "'")
            //return "<dl>" + groupInputs.map(i => "<dt class='font-weight-bold'>" + i.question + "</dt><dd class='pl-2'>" + i.answer + "</dd>").join('') + "</dl>"
            // We now do these explicitly, after the intro, rather than as a substitution
            return "";
        });
        const regex2 = /\[\[resources\]\]/g;
        // eslint-disable-next-line no-unused-vars
        newText = newText.replace(regex2, function (found) {
            //console.log("Translating '" + found + "'")
            return importedGroupModel.resources
                .map(s => "<div class='mb-2'><h4>" + s.groupTitle + "</h4>" 
                    + "<ul>" 
                    + s.items.map(i => "<li class='font-weight-bold no-bullet'><a href='" + i.uri + "'>" + i.text + "</a></li>").join('') 
                    + "</ul></div>").join('')
        });
        const regex3 = /\[\[ref:([^,]+),(.+)\]\]/g;
        newText = newText.replace(regex3, function (match, $1, $2) {
            //console.log("Translating ref '" + match + "'")
            return "<a href='" + $2 + "' target='_blank'>" + $1 + "</a>"
        });
        return newText;
    }
    aggregate(groupId, format, questions, answers) {
        const calc = new ScoreCalculator();
        const textInfo = importedGroupModel.groupInfo.find(g => g.groupId == groupId); // TODO Check
        const texts = textInfo[format]; // TODO Check
        const groupAnswers = calc.aggregateAnswers(groupId, questions, answers);
        const groupInputs = calc.aggregateInputs(groupId, questions, answers);
        const opinion = calc.getOpinionForScore(groupAnswers.unweightedScore)
        const tips = `You scored ${formatNumber(groupAnswers.unweightedScore, 1)} out of 5. ` 
            + opinion.comment + '\n' 
            + texts.tips 
        return {
            groupId: groupId,
            name: textInfo.name,
            title: texts.title,
            intro: this.processText(texts.intro, format, questions, groupAnswers, groupInputs),
            inputs: groupInputs,
            tips: this.processText(tips, format, questions, groupAnswers, groupInputs),
            hasTips: !!texts.tips,
            answers: groupAnswers,
            unweightedScore: groupAnswers.unweightedScore,
            weighting: groupAnswers.weighting,
            weightedScore: groupAnswers.weightedScore,
            isScored: groupAnswers.items.length > 0
        }
    }
    getTotalScore(allGroups) {
        const scoringGroups = allGroups.filter(g => g.isScored)
        const totalScore = sum(scoringGroups.map(g => g.weightedScore))
        const totalWeights = sum(scoringGroups.map(g => g.weighting))/5
        const total = totalScore / (totalWeights ? totalWeights : 1)
        return total;
    }
}